import {
  PostHogFeature as BasePostHogFeature,
  PostHogFeatureProps,
} from 'posthog-js/react'

/**
 * Wrapper component for PostHogFeature that automatically enables the feature flag in the Shopify admin.
 *
 * @param props - Accepts the same props as the original component from posthog-js/react.
 */
export const PostHogFeature: React.FC<
  React.PropsWithChildren<PostHogFeatureProps>
> = (props) => {
  const isShopifyAdmin =
    typeof window !== 'undefined' &&
    typeof window.Shopify !== 'undefined' &&
    window.Shopify.designMode

  const match = isShopifyAdmin ? undefined : props.match

  return (
    <BasePostHogFeature {...props} match={match}>
      {props.children}
    </BasePostHogFeature>
  )
}
